import { useEffect, useMemo, useState } from 'react';
import { getSystemMode } from '../utils/theme';
import { useAppearance } from './useAppearance';

const useIconColor = () => {
  const [currentMode, setCurrentMode] = useState<'light' | 'dark'>();
  const { appearance } = useAppearance();

  useEffect(() => {
    if (appearance?.mode && appearance?.mode !== 'auto') {
      setCurrentMode(appearance?.mode);
    } else {
      setCurrentMode(getSystemMode());
    }
  }, [appearance?.mode]);

  const foreground = useMemo(() => {
    if (currentMode === 'dark') {
      return '#000000';
    } else {
      return '#ffffff';
    }
  }, [currentMode]);

  const background = useMemo(() => {
    if (currentMode === 'dark') {
      return '#ffffff';
    } else {
      return '#000000';
    }
  }, [currentMode]);

  return { foreground, background, currentMode };
};

export default useIconColor;
